import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Helmet } from 'react-helmet';

// Styles and images
import appStyles from './App.module.css';

// Layout
import Header from './layout/Header';
import Footer from './layout/Footer';
import Background from './layout/Background';

// Pages
import About from './pages/about';
import Contact from './pages/contact';
import Events from './pages/events';
import Music from './pages/music';
import NotFound from './pages/404';
import PlaylistToCart from './pages/playlist-to-cart';

// Add the necessary social icons to the library
library.add(fab);

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  return (
    <div className={appStyles.main + ' ' + (isHomePage ? appStyles.mainCenter : appStyles.mainTop)}>
      <Header />
      <div className={appStyles.content}>
        <Routes>
          <Route path="/" element={<></>} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/events" element={<Events />} />
          <Route path="/music" element={<Music />} />
          <Route path="/playlist-to-cart" element={<PlaylistToCart />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Background zoom={isHomePage} shake={isHomePage} fade={!isHomePage} location={location} />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Helmet defaultTitle="RickyRombo - DJ. Producer. Artist." titleTemplate="%s | RickyRombo" />
      <div className={appStyles.wrapper}>
        <AppContent />
      </div>
    </BrowserRouter>
  );
}

export default App;
